export default "__VITE_ASSET__C0U6vlNC__"